import { render, staticRenderFns } from "./EventFormPage.vue?vue&type=template&id=a49335da&"
import script from "./EventFormPage.vue?vue&type=script&lang=js&"
export * from "./EventFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports